export const EMPRESAS_SORT_GROUPS = [
  {
    id: 'geral',
    label: 'Geral',
    options: [
      { label: 'Relevância', value: '' },
      { label: 'Nome da empresa (A-Z)', value: 'pessoa_fantasia ASC' },
      { label: 'Nome da empresa (Z-A)', value: 'pessoa_fantasia DESC' }
    ]
  },
  {
    id: 'patrimonio-capital-social',
    label: 'Patrimônio e capital social',
    options: [
      { label: 'Maior patrimônio líquido', value: 'pl DESC' },
      { label: 'Menor patrimônio líquido', value: 'pl ASC' },
      { label: 'Maior capital social', value: 'cs DESC' },
      { label: 'Menor capital social', value: 'cs ASC' }
    ]
  }
];

/** Converte os grupos visuais na lista única usada para seleção e validação. */
function pvFlattenSortGroups(pGroups) {
  return pGroups.flatMap(pGroup => pGroup.options || []);
}

export const EMPRESAS_SORT_OPTIONS = pvFlattenSortGroups(EMPRESAS_SORT_GROUPS);
